import RightPopupComponent from "components/RightPopup";

import SelectDate from "components/SelectDate";
import InputPhone from "components/InputPhone";
import InputNameSex from "components/InputNameSex";

import { ReactComponent as VipIcon } from 'icons/pages/app/vip.svg';
import { ReactComponent as PatientStaffIcon } from 'icons/pages/app/patientStaff.svg';
import { ReactComponent as SmileKeeperIcon } from 'icons/pages/app/smilkeeper.svg';
import { ReactComponent as GratitudeIcon } from 'icons/pages/app/gratitude.svg';

import '../index.less';
import '../themes/default.less';

export default class MainInfo extends RightPopupComponent {

    render() {
        const { info, onChangeLName, onChangeFName, onChangeSName, onChangeDateBirth,
            renderAvatar, onChangeSex, setInfoState, onChangePhone, changeInfoState,
            onChangePersonalDate, setTreatmentStatus } = this.props;
        const { lname, fname, sname, birthday, sex, status, phoneNumber, lkSearchAttr1,
            vipStatus, smileKeeper, isEmployee, personalData, isGratitude, statusTreatment: st } = info;

        //const sexValue = sex === "FEMALE" ? 1 : sex === "MALE" ? 0 : null;
        const { clientStatuses, statusTreatment } = this._config;

        return (<div className="flex gap16 col" >
            {renderAvatar()}
            <div className="inputs flex gap4">
                {/*this.insertInput({
                    value: lname,
                    itemStyle: "flex1",
                    label: "main.lname",
                    placeHolder: "main.lnamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: onChangeLName,
                    required: true,
                })*/}
                {/*this.insertInput({
                    value: fname,
                    itemStyle: "flex1",
                    label: "main.fname",
                    placeHolder: "main.fnamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: onChangeFName,
                    required: true,
                })*/}
                <InputNameSex
                    ref={el => this.inputNameSex = el}
                    fname={fname}
                    sname={sname}
                    lname={lname}
                    onChangefname={onChangeFName}
                    onChangesname={onChangeSName}
                    onChangelname={onChangeLName}
                    onClick={onChangeSex}
                    sex={sex}
                />
                {/*this.insertInput({
                    value: sname,
                    itemStyle: "flex1",
                    label: "main.sname",
                    placeHolder: "main.snamePlace",
                    validator: this._helper.inputValidators.capitalize,
                    onChange: onChangeSName,
                })*/}
            </div>
            <SelectDate currentday={birthday} onClick={onChangeDateBirth} />
            {/*<div className="flex col gap8">
                {this.insertSexSelect({
                    value: sexValue,
                    label: "client.sex",
                    onChange: onChangeSex,
                })}
            </div>*/}
            <div className="flex flex1 gap16">
                <div className="flex flex1 col gap8">
                    <InputPhone
                        value={phoneNumber}
                        itemStyle="flex1"
                        label="main.telephone"
                        onChange={onChangePhone.bind(this, "phoneNumber")}
                        required={true}
                    />
                    <div className="flex flex1 start">
                        {this.insertCheckBox({
                            checked: lkSearchAttr1 ? true : false,
                            title: this._helper.string.capitalize(this.tr("client.basicPhone")),
                            onClick: changeInfoState.bind(this, "lkSearchAttr1", lkSearchAttr1 ? false : true)
                        })}
                    </div>
                </div>
                <InputPhone
                    value={personalData['PHONE_1']}
                    itemStyle="flex1"
                    label="client.homePhone"
                    onChange={onChangePhone.bind(this, "homePhone")}
                />

            </div>
            <div className="flex flex1 gap16">
                {this.insertSelect({
                    value: status,
                    label: "client.status",
                    showLeftIcon: false,
                    placeHolder: "main.notIndicated",
                    translate: true,
                    items: clientStatuses,
                    onChange: setInfoState,
                })}
                {this.insertSelect({
                    value: st,
                    label: "Статус лечения",
                    showLeftIcon: false,
                    placeHolder: "main.notIndicated",
                    translate: true,
                    items: statusTreatment,
                    onChange: setTreatmentStatus,
                })}
            </div>
            <div className="flex flex1 gap16">
                <div className="flex col flex1 gap8">
                    <div className="flex gap8">
                        {this.insertCheckBox({
                            checked: vipStatus ? true : false,
                            title: "client.vip",
                            onClick: changeInfoState.bind(this, "vipStatus", !vipStatus)
                        })}
                        <VipIcon />
                    </div>
                    <div className="flex gap8">
                        {this.insertCheckBox({
                            checked: smileKeeper ? true : false,
                            title: "SmileKeeper",
                            onClick: changeInfoState.bind(this, "smileKeeper", !smileKeeper)
                        })}
                        <SmileKeeperIcon />
                    </div>
                    <div className="flex gap8">
                        {this.insertCheckBox({
                            checked: isEmployee ? true : false,
                            title: "Сотрудник",
                            onClick: changeInfoState.bind(this, "isEmployee", !isEmployee)
                        })}
                        <PatientStaffIcon />
                    </div>
                    <div className="flex gap8">
                        {this.insertCheckBox({
                            checked: isGratitude ? true : false,
                            title: "Программа благодарности",
                            onClick: changeInfoState.bind(this, "isGratitude", !isGratitude)
                        })}
                        <GratitudeIcon />
                    </div>
                </div>
            </div>
            <div className="flex flex1 gap16">
                {this.insertInput({
                    value: personalData['EMAIL'],
                    itemStyle: "flex1",
                    label: "client.email",
                    placeHolder: "mail@mail.ru",
                    onChange: onChangePersonalDate.bind(this, "EMAIL")
                })}

            </div>
            {this.insertTextarea({
                value: personalData['SPEC_NOTES'],
                label: "client.specMarks",
                placeHolder: "main.freeComment",
                onChange: onChangePersonalDate.bind(this, "SPEC_NOTES")
            })}
        </div>
        );
    }
}
